import { HTTPClient } from "../common/HTTPClient";
import { AuthClient } from "./AuthClient";
import { ShopClient } from "./ShopClient";
import { ChannelClient } from "./ChannelClient";
import { PermissionClient } from "./PermissionClient";
import { RoleClient } from "./RoleClient";
import { UserClient } from "./UserClient";
import { MigrateClient } from "./MigrateClient";
import { ItemClient } from "./ItemClient";
import { PromotionClient } from "./PromotionClient";
import { OrderClient } from "./OrderClient";
import { CategoryClient } from "./CategoryClient";
import { ShopifyClient } from "./ShopifyClient";
import { DeliveryModeClient } from "./DeliveryModeClient";
import { MarketplaceClient } from "./MarketplaceClient";
import { ErrorTrackingClient } from "./ErrorTrackingClient";
import { ShopDeliveryClient } from "./ShopDeliveryClient";
import { RawStatusMappingClient } from "./RawStatusMappingClient";
import { ShipnityClient } from "./ShipnityClient";
import { LineClient } from "./LineClient";
import { ApiBridgeSystemClient } from "./ApiBridgeSystemClient";
import { ShippopClient } from "./ShippopClient";
import { TMSClient } from "./TMSClient";
import { NotificationClient } from "./NotificationClient";

export class Client {
  constructor(private httpClient: HTTPClient) {}

  public auths: AuthClient = new AuthClient(this.httpClient);
  public shops: ShopClient = new ShopClient(this.httpClient);
  public channels: ChannelClient = new ChannelClient(this.httpClient);
  public permissions: PermissionClient = new PermissionClient(this.httpClient);
  public roles: RoleClient = new RoleClient(this.httpClient);
  public users: UserClient = new UserClient(this.httpClient);
  public migrates: MigrateClient = new MigrateClient(this.httpClient);
  public items: ItemClient = new ItemClient(this.httpClient);
  public promotions: PromotionClient = new PromotionClient(this.httpClient);
  public orders: OrderClient = new OrderClient(this.httpClient);
  public categories: CategoryClient = new CategoryClient(this.httpClient);
  public shopify: ShopifyClient = new ShopifyClient(this.httpClient);
  public deliveryMode: DeliveryModeClient = new DeliveryModeClient(
    this.httpClient
  );
  public marketplaces: MarketplaceClient = new MarketplaceClient(
    this.httpClient
  );
  public errorTracking: ErrorTrackingClient = new ErrorTrackingClient(
    this.httpClient
  );
  public shopDelivery: ShopDeliveryClient = new ShopDeliveryClient(
    this.httpClient
  );

  public rawStatusMapping: RawStatusMappingClient = new RawStatusMappingClient(
    this.httpClient
  );
  public shipnity: ShipnityClient = new ShipnityClient(this.httpClient);
  public line: LineClient = new LineClient(this.httpClient);
  public bridgeSystem: ApiBridgeSystemClient = new ApiBridgeSystemClient(
    this.httpClient
  );
  public shippop: ShippopClient = new ShippopClient(this.httpClient);
  public tms: TMSClient = new TMSClient(this.httpClient);
  public notification: NotificationClient = new NotificationClient(
    this.httpClient
  );
}
